import './App.css';
import { GoShare } from "react-icons/go"
import { AiOutlineArrowDown } from "react-icons/ai"
import logo from "./icons/Animated Logo.gif";

function Install() {
  return (
    <div className="App">
      <header className="App-header" >
        <div className="App-icon">
          <img src={logo} className="App-logo" />
        </div>
        <p style={{ padding: "2rem" }}>
          Add #OOTD to your home screen by clicking the share button below and then pressing "Add to Home Screen"
        </p>
        <div>
          <GoShare size="3rem" color="#007aff" />
        </div>
        <div>
          <AiOutlineArrowDown />
        </div>
      </header>
    </div>
  );
}

export default Install;
